import { errorReporter, rootReducer } from '@team/steps-core';
import { slice } from './slice';

slice.injectInto(rootReducer);
errorReporter.inject(slice.actions.errorOccured, 'system');
